export default __webpack_public_path__ + "static/media/DF_Characters_Courtney1.fa3b2f38.png";